import { useContext } from 'react';
import { EapSettingsListContext, EapSettingsListContextType } from '../eap-settings-list.context';

export const useEapSettingsListContext = (): EapSettingsListContextType => {
    const context = useContext(EapSettingsListContext);
    if (context === undefined) {
        throw new Error('useEapSettingsListContext must be used within EapSettingsListProvider');
    }
    return context;
};
